module.exports = __webpack_public_path__ + "img/SeasonOfPride2021_Mobile.f1681c59.jpg";